import loader from "@monaco-editor/loader";

if (process.env.NODE_ENV === "production") {
  loader.config({ paths: { vs: "/v1/js/vs" }, "vs/nls": { availableLanguages: {} } });
}
